module.exports = __webpack_public_path__ + "static/media/editar.d0fa90a5.svg";